// extracted by mini-css-extract-plugin
module.exports = {"Delta3MaxSeriesA":"StatusA_Delta3MaxSeriesA__q3_V4"};